<template>
  <div class="container mt-2 position-relative">
    <!-- <h2>{{ $t('buscarPersonas') }}</h2> -->
    <div class="d-flex flex-row align-items-center gap-2 mb-2">
      <div class="d-flex align-items-center position-relative w-100">
        <input type="text" class="form-control m-0 sombra-sm" style="height: 40px;" :placeholder="$t('buscarPorNombre') + '...'" v-model="searchTerm" @keyup.enter="fetchUsers(1)" @input="filterUsers"/>
        <button v-if="searchTerm" type="button" class="position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent" @click="searchTerm = ''; fetchUsers(1); saveFilterState()">
          <i class="bi bi-x text-secondary" style="font-size: 30px;"></i> <!-- Icono de "x" -->
        </button>
      </div>
      <div class="d-flex align-items-center justify-content-center">
        <div class="rounded-2 fondo-terciario sombra-sm d-flex align-items-center justify-content-center p-2 position-relative"
          @click="showFilters = !showFilters" 
          style="cursor: pointer;">
          
          <svg width="24" height="24" viewBox="0 0 24 24" id="filter" data-name="Line Color" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
            <path id="primary" d="M5,4V6.64a1,1,0,0,0,.23.64l4.54,5.44a1,1,0,0,1,.23.64V21l4-2V13.36a1,1,0,0,1,.23-.64l4.54-5.44A1,1,0,0,0,19,6.64V4a1,1,0,0,0-1-1H6A1,1,0,0,0,5,4Z" style="fill: none; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"></path>
          </svg>

          <span v-if="activeFiltersCount > 0" 
                class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger mt-1 me-2"
                style="font-size: 0.65rem;">
            {{ activeFiltersCount }}
          </span>
        </div>
      </div>
      <div class="tooltip-container">
        <svg xmlns="http://www.w3.org/2000/svg" width="15" class="stroke-secundario" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="16" x2="12" y2="12"></line>
          <line x1="12" y1="8" x2="12" y2="8"></line>
        </svg>
        <span class="tooltip-text-left fondo-secundario border-0" style="max-width: 50vw; min-width: 300px;">
          <p class="m-0 fs-8 texto-principal">{{ $t('searchValuesPersonas') }}</p>
        </span>
      </div>
      <router-link v-if="hasAgregarPersonaPermission" to="/personas/agregarPersona" class="btn bg-goethe-accent p-1 rounded sombra-sm ms-1">
        <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M6 12H18M12 6V18" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </router-link>
    </div>
    <div v-if="showFilters" class="fondo-terciario p-3 px-4 sombra-sm position-absolute rounded-3 d-flex flex-column gap-4" style="top: 50%; left: 50%; transform: translate(-50%, -50%); width: 600px; max-width: 90vw; z-index: 2101;">
      <div class="d-flex flex-column gap-3">
        <div class="w-100 d-flex justify-content-between align-items-center gap-5 mt-2 p-0"> 
          <label class="m-0 fw-bold fs-5">{{ $t('filtros') }}:</label>
          <button type="button" class="btn p-0" @click="showFilters = false">
            <svg width="20" height="20" viewBox="5 5 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect id="Rectangle" fill-rule="nonzero" x="0" y="0" width="24" height="24"></rect>
                <line x1="16.9999" y1="7" x2="7.00001" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
                <line x1="7.00006" y1="7" x2="17" y2="16.9999" id="Path" class="stroke-principal" stroke-width="2" stroke-linecap="round"></line>
              </g>
            </svg>
          </button>
        </div>
        <div class="w-100">
          <label for="filtroRol" class="form-label texto-principal fw-bold">{{ $t('rol') }}:</label>
          <div class="d-flex flex-wrap gap-2 align-items-start w-100">
            <div v-for="rol in roles" :key="rol"
              class="form-check-pill"
              :class="{ 'checked': rol.checked }"
              style="cursor: pointer; min-height: 35px;"
              @click="rol.checked = !rol.checked">
              <span class="texto-principal">
                {{ $t(rol.Rol.toLowerCase()) }}
              </span>
            </div>
          </div>
        </div>

        <div class="w-100">
          <label for="filtroEstado" class="form-label texto-principal fw-bold">{{ $t('estado') }}:</label>
          <div class="d-flex flex-wrap gap-2 align-items-start w-100">
            <div v-for="estado in estados" :key="estado"
              class="form-check-pill"
              :class="{ 'checked': estado.checked }"
              style="cursor: pointer; min-height: 35px;"
              @click="estado.checked = !estado.checked">
              <span class="texto-principal">
                {{ estado.Estado ? $t(estado?.Estado) : 'Estado desconocido' }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2">
        <button class="btn home-list ps-2 d-flex gap-2" @click="clearFilters">
          <svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" 
            width="22" height="22" viewBox="0 0 32 32" xml:space="preserve" class="stroke-principal" 
            style="fill:none;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;">
            <path class="st0" d="M14,17V3c0-1.1,0.9-2,2-2h0c1.1,0,2,0.9,2,2v14"/>
            <line class="st0" x1="14" y1="14" x2="18" y2="14"/>
            <path class="st0" d="M26,31H6l2.7-12.4c0.2-0.9,1-1.6,2-1.6h10.8c0.9,0,1.8,0.7,2,1.6L26,31z"/>
            <line class="st0" x1="9" y1="21" x2="23" y2="21"/>
            <line class="st0" x1="11" y1="27" x2="11" y2="30"/>
            <line class="st0" x1="21" y1="29" x2="21" y2="30"/>
          </svg>
          <span class="texto-principal">{{ $t('limpiarFiltros') }}</span>
        </button>
        <button class="btn bg-goethe-accent texto-principal" @click="applyFilters">
          <span class="texto-principal">{{ $t('filtrar') }}</span>
        </button>
      </div>
    </div>
    <!-- Backdrop (solo si el menú está abierto) -->
    <div v-if="showFilters" class="overlay" @click="showFilters = false"></div>

    <table class="table-striped w-100 mb-2 sombra-sm">
      <thead>
        <tr>
          <th @click="sortTable('apellido')" style="cursor: pointer;" class="user-select-none">
            {{ $t('apellido') }}
            <span v-if="sortKey === 'apellido'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th @click="sortTable('nombre')" style="cursor: pointer;" class="user-select-none">
            {{ $t('nombre') }}
            <span v-if="sortKey === 'nombre'">{{ sortDirection === 'asc' ? '↑' : '↓' }}</span>
          </th>
          <th style="cursor: pointer;" class="user-select-none d-none d-sm-table-cell">
            Email
          </th>
          <th style="cursor: pointer;" class="user-select-none d-none d-md-table-cell">
            {{ $t('roles') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <template v-for="user in users" :key="user.IdPersona">
          <!-- Fila de información del usuario -->
          <tr  @click="toggleDetalle(user.IdPersona)" style="cursor: pointer;">
            <td class="fs-8 align-middle p-2">
              <span class="text-truncate d-block" style="max-width: 100%; white-space: nowrap;">
                {{ user.Apellido }}
              </span></td>
            <td class="fs-8 align-middle p-2">{{ user.Nombre }}</td>
            <td class="fs-8 align-middle p-2 d-none d-sm-table-cell">{{ user.Emails }}</td>
            <td class="fs-8 align-middle p-2 d-none d-md-table-cell roles-column">
              <div class="">
                <div class="d-flex gap-2">
                  <div v-for="hist in user.Roles" :key="hist.IdHistorialPersonaRol" class="item-pill rounded-pill px-2 py-0 fs-8 m-0 d-flex flex-inline align-items-center"
                      :class="'fondo-'+hist.Estado?.Color+'-2'">
                    <p class="m-0 item-name">{{ hist?.Rol?.Rol }}</p>
                    <!-- <span class="m-0 spacer">-</span> -->
                    <p class="m-0 item-extra">&nbsp;- {{ hist?.Estado?.Estado }}</p>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </template>
      </tbody>
    </table>

    <!-- Controles de Paginación --> 
    <nav aria-label="Page navigation" class="d-flex flex-column flex-sm-row gap-2 justify-content-between">
      <div class="d-flex flex-row gap-3 align-items-center">
        <ul class="pagination m-0">
          <li class="p-2 rounded-start bg-goethe-accent-claro-3 borde-secundario border-1 border-end sombra-sm cursor-pointer" :class="{ disabled: currentPage === 1 }" @click.prevent="changePage(currentPage - 10)">
            <svg width="20" height="20" viewBox="3 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg)">
              <path d="m13 16 4-4-4-4M7 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </li>
          <li class="p-2 px-3 rounded-start bg-goethe-accent-claro-3 borde-secundario border-1 border-end sombra-sm cursor-pointer" :class="{ disabled: currentPage === 1 }" @click.prevent="changePage(currentPage - 1)">
            <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(180deg)">
              <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </li>
          <li class="p-2 bg-goethe-accent-claro-3 borde-secundario sombra-sm">
            <a class="p-2 text-dark text-decoration-none" href="#" @click.prevent="">{{ currentPage }} {{$t('de')}} {{ totalPages }}</a>
          </li>
          <li class="p-2 px-3 rounded-end bg-goethe-accent-claro-3 borde-secundario border-1 border-start sombra-sm cursor-pointer" :class="{ disabled: currentPage === totalPages }" @click.prevent="changePage(currentPage + 1)">
            <svg width="20" height="20" viewBox="6 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="m13 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </li>
          <li class="p-2 rounded-end bg-goethe-accent-claro-3 borde-secundario border-1 border-start sombra-sm cursor-pointer" :class="{ disabled: currentPage === totalPages }" @click.prevent="changePage(currentPage + 10)">
            <svg width="20" height="20" viewBox="3 3 18 18" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="m13 16 4-4-4-4M7 16l4-4-4-4" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </li>
        </ul>
        <p class="m-0">{{ totalItems + " " + $t('personas') }}</p>
        <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
          <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  import { ref, onMounted, computed } from 'vue';
  import {useStore} from "vuex";
  import {useRouter} from "vue-router";
  import { useI18n } from 'vue-i18n';
  import api from '@/services/api';

export default {
  name: 'VerPersonas',
  setup() {
    const { t } = useI18n();
    const users = ref([]);
    var searchTerm = ref(localStorage.getItem('filter_searchTerm') || '');
    var currentPage = ref(1);
    var totalPages = ref(1);
    var totalItems = ref(0);
    var loading = ref(false);
    var hasAgregarPersonaPermission = ref(false);
    const router = useRouter();
    const store = useStore();
    const user = computed(() => store.state.user);
    const sortKey = ref('');
    const sortDirection = ref('asc'); // 'asc' o 'desc'
    let timeoutId = null;
    const showFilters = ref(false);
    const roles = ref([]);
    const estados = ref([]);


    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        var categoriaAComprobar = 'VerPersonas'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.subCategoria === categoriaAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.subCategoria === categoriaAComprobar))){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
        
        var permisoAComprobar = 'AgregarPersonas'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
          hasAgregarPersonaPermission.value = true;
        }
      }
    };

    // Fetch roles de la BD
    const fetchRoles = async () => {
      try {
        const response = await api.get(`api/Roles`);
        const savedRoles = JSON.parse(localStorage.getItem('filter_roles') || '[]');
      
        roles.value = response.data.map(rol => ({
          ...rol,
          checked: savedRoles.includes(rol.IdRol) // Restaurar estado
        }));
        //console.log(roles.value)
      } catch (error) {
        console.error('Error al obtener roles:', error);
      }
    };

    const fetchEstados = async () => {
      try {
        const response = await api.get(`api/ExtrasPersonas/Estados`);
        const savedEstados = JSON.parse(localStorage.getItem('filter_estados') || '[]');
        
        estados.value = response.data.map(estado => ({
          ...estado,
          checked: savedEstados.includes(estado.IdEstado) // Restaurar estado
        }));
        //console.log(estados.value)
      } catch (error) {
        console.error('Error al obtener datos del usuario:', error);
      }
    };

    const fetchUsers = async (page) => {
      try {
        loading.value = true
        if (timeoutId) {
          clearTimeout(timeoutId);
        }

        currentPage.value = page;

        // 1. Construimos un objeto JavaScript plano con todos los parámetros.
        const params = {
          Page: currentPage.value,
          PageSize: 15, // Puedes hacerlo una constante o una ref si cambia
        };

        // 2. Añadimos los parámetros condicionales de forma mucho más limpia.
        if (searchTerm.value) {
          params.SearchValue = searchTerm.value;
        }

        if (sortKey.value) {
          params.ValorDeOrden = `${sortKey.value}_${sortDirection.value}`;
        }

        // 3. Usamos .map() para obtener directamente los arrays de valores. Es más conciso.
        const rolesSeleccionados = roles.value
          .filter(r => r.checked)
          .map(r => r.IdRol);
        
        const estadosSeleccionados = estados.value
          .filter(e => e.checked)
          .map(e => e.IdEstado);

        // 4. Si hay selecciones, las añadimos al objeto de parámetros.
        if (rolesSeleccionados.length > 0) {
          params.RolFiltro = rolesSeleccionados;
        }
        
        if (estadosSeleccionados.length > 0) {
          params.EstadoFiltro = estadosSeleccionados;
        }

        // Crea un objeto URLSearchParams
        const queryParams = new URLSearchParams();

        // Itera sobre los parámetros
        for (const key in params) {
            const value = params[key];

            if (Array.isArray(value)) {
                // Si es un array, añade cada elemento con la misma clave
                value.forEach(item => {
                    queryParams.append(key, item);
                });
            } else if (value !== null && value !== undefined) {
                // Si no es un array, añádelo normalmente
                queryParams.append(key, value);
            }
        }

        // Ahora, pasa la cadena de consulta generada
        console.log(queryParams.toString()); 
        // Output: Page=1&PageSize=15&SearchValue=bren&RolFiltro=2bef46cb-2393-4626-ab12-55f7c48377d2

        const response = await api.get(`api/Persona/DatosBasicos?${queryParams.toString()}`);


        users.value = response.data.Items; // Asumiendo que la respuesta contiene un array de usuarios
        totalPages.value = response.data.TotalPages;
        totalItems.value = response.data.TotalItems;
        console.log(response.data)
        loading.value = false
      } catch (error) {
        console.error('Error al obtener usuarios:', error);
        loading.value = false
      }
    };
    // Aplica los filtros seleccionados y busca desde la primera página
    const applyFilters = () => {
      saveFilterState(); // Guardar antes de buscar
      fetchUsers(1);
      showFilters.value = false;
    };

    // Limpia los filtros y vuelve a cargar los datos
    const clearFilters = () => {
      roles.value.forEach(r => r.checked = false);
      estados.value.forEach(r => r.checked = false);
      searchTerm.value = '';
      // Limpiar localStorage
      localStorage.removeItem('filter_searchTerm');
      localStorage.removeItem('filter_roles');
      localStorage.removeItem('filter_estados');
      fetchUsers(1);
    };

    const filterUsers = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        saveFilterState(); // Guardar término de búsqueda
        fetchUsers(1);
      }, 500);
    };

    const changePage = (page) => {
      if (page < 1){
        currentPage.value = 1;
      }
      else if (page > totalPages.value){
        currentPage.value = totalPages.value;
      }
      else {
        currentPage.value = page;
      }
      fetchUsers(currentPage.value)
    };

    const toggleDetalle = async (userId) => {
      await router.push(`/personas/verDatosPersona?id=${userId}`);
    };


    const sortTable = (key) => {
      if (sortKey.value === key) {
        // Si es la misma columna, invierte la dirección de orden
        sortDirection.value = sortDirection.value === 'asc' ? 'desc' : 'asc';
      } else {
        // Si es una nueva columna, ordena ascendentemente
        sortKey.value = key;
        sortDirection.value = 'asc';
      }
      fetchUsers(currentPage.value)
    };

    const activeFiltersCount = computed(() => {
      const rolesCount = roles.value.filter(r => r.checked).length;
      const estadosCount = estados.value.filter(e => e.checked).length;
      return rolesCount + estadosCount;
    });

    // Función para guardar el estado de los filtros
    const saveFilterState = () => {
      localStorage.setItem('filter_searchTerm', searchTerm.value);

      const selectedRoles = roles.value.filter(r => r.checked).map(r => r.IdRol);
      const selectedEstados = estados.value.filter(e => e.checked).map(e => e.IdEstado);
      
      localStorage.setItem('filter_roles', JSON.stringify(selectedRoles));
      localStorage.setItem('filter_estados', JSON.stringify(selectedEstados));
    };

    onMounted(async () => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      checkAuth();
      await fetchRoles();
      await fetchEstados();
      if(users.value.length==0){
        fetchUsers(1);
      }
    });

    return {
      searchTerm,
      changePage,
      currentPage,
      totalPages,
      sortTable,
      checkAuth,
      sortKey,
      sortDirection,
      toggleDetalle,
      loading,
      t,
      users,
      hasAgregarPersonaPermission,
      filterUsers,
      fetchUsers,
      applyFilters,
      clearFilters,
      showFilters,
      roles,
      estados,
      totalItems,
      activeFiltersCount,
      saveFilterState,
    };
  },
};
</script>

<style>
.permissions-list {
  margin-top: 10px;
}

.roles-column {
  width: 250px; /* Fixed width for roles column */
}
</style>

